import special from "../modules/special.js"
export default [
    // 链信-官网-首页
    { path: '/', name: '', component: special.lianxinAppIntro,meta: { single: true}},
    // 资产证券化
    { path: "/equity.xhtml", name: "equity", component: special.equity, meta: { headerOpacity: '1', title: "资产证券化", background: '#683f17'} },
    // 中燃集团登录定制
    { path: "/chinaGas.xhtml", name: "chinaGas", component: special.chinaGas, meta: { title: "中燃物资供应链管理(深圳)有限公司", single: true } },
    // 云租宣传页
    { path: "/yz.xhtml", name: "yz", component: special.yz, meta: { title: "云租" } },
    
    // 合同管理登录界面
    { path: '/yqLogin.xhtml', name: 'yqLogin', component: special.yqLogin, meta: { headerOpacity: '1', title: "云签",background: '#ffffff', footerbg: '#ffffff', ftColor: '#919398' } },

    
    // 页面迁移-登录前
    // 易捷专题
    { path: '/yijie.xhtml', name: 'yijie', component: special.yijie, meta: { headerOpacity: '1', title: "易捷",single: true}},
    // 京投登录
    { path: '/biiLogin.xhtml', name: 'bilLogin', component: special.bilLogin,meta: { headerOpacity: '1', title: "京投",single: true}},
    // 天道金科登录
    { path: '/tdftLogin.xhtml', name: 'tdftLogin', component: special.tdftLogin,meta: { headerOpacity: '1', title: "天道金科",single: true}},
    // 票转信-产品介绍
    { path: '/produceInfo.xhtml', name: 'produceInfo', component: special.produceInfo,meta: { headerOpacity: '1', title: "票转信",background: '#0a52b4',single: true}},
    // 票转信-产品咨询
    { path: '/produceZX.xhtml', name: 'produceZX', component: special.produceZX,meta: { headerOpacity: '1', title: "票转信",background: '#150440'}},
    // 资产处置回收
    { path: '/assetRecovery.xhtml', name: 'assetRecovery', component: special.assetRecovery,meta: { headerOpacity: '1', title: "资产处置回收",single:true}},
    // 信用查询
    { path: '/queryCompanyCredit.xhtml', name: 'queryCompanyCredit', component: special.queryCompanyCredit,meta: { headerOpacity: '1', title: "信用查询",single:true}},
    
    // 镇江专题
    // 镇江index
    { path: '/zjindex.xhtml', name: 'zjindex', component: special.zjindex,meta: { title: "", single: true }},
    // 镇江-云信
    { path: '/zjyunxin.xhtml', name: 'zjyunxin', component: special.zjyunxin,meta: { title: "", single: true }},
    // 镇江—云证
    { path: '/zjyunzheng.xhtml', name: 'zjyunzheng', component: special.zjyunzheng,meta: { title: "", single: true }},
    // 镇江—云投
    { path: '/zjyuntou.xhtml', name: 'zjyuntou', component: special.zjyuntou,meta: { title: "", single: true }},
    // 镇江—融资租赁
    { path: '/zjrzzl.xhtml', name: 'zjrzzl', component: special.zjrzzl,meta: { title: "", single: true }},
    // 镇江—票转信
    { path: '/zjpzx.xhtml', name: 'zjpzx', component: special.zjpzx,meta: { title: "", single: true }},
    // 镇江—联系我们
    { path: '/zjcontactUs.xhtml', name: 'zjcontactUs', component: special.zjcontactUs,meta: { title: "", single: true }},
    
    // 新闻list
    { path: '/new_content.xhtml', name: 'new_content', component: special.new_content,meta:{single:true}},
    // 新闻详情
    { path: '/new_detail.xhtml', name: 'new_detail', component: special.new_detail,meta:{single:true}},

    // 链信专题
    { path: '/lianxin.xhtml', name: 'lianxin', component: special.lianxin, meta: { title: "链信",background: '#1c77e0'}},
    // 链信-官网-首页
    { path: '/lianxinAppIntro.xhtml', name: 'lianxinAppIntro', component: special.lianxinAppIntro,meta: { single: true}},
    // 融资租赁
    { path: '/rzzl.xhtml', name: 'rzzl', component: special.rzzl,meta: { headerOpacity: '1', title: "融资租赁",background:'#150440'}},
    // 云投-旧版本
   { path: '/yuntou_old.xhtml', name: 'yuntou_old', component: special.yuntou_old,meta: { headerOpacity: '1', title: "云投",background: '#150440'}},
    // 云投
   { path: '/yuntou.xhtml', name: 'yuntou', component: special.yuntou,meta: { headerOpacity: '0', title: "云投",background: 'none'}},
    // 政E信宣传页
    { path: '/ZEXin.xhtml', name: 'ZEXin', component: special.ZEXin,meta: { headerOpacity: '0', title: "政采信",background: 'none'}},
    
    // 企业函证邮箱
    { path: '/hzEmail.xhtml', name: 'hzEmail', component: special.hzEmail,meta: { title: "", single: true }},


    // 中企云链-企业好友
    { path: '/InviteFriends', name: 'InviteFriends', component: special.InviteFriends,meta: { title: "中企云链-企业好友", single: true }},

    // 优惠券静态页
    { path: '/Coupons.xhtml', name: 'Coupons', component: special.Coupons,meta: { title: "优惠券", single: true }},

	//链信 消息发送-公告通知 消息正文
	{ path: '/Lx/sendMessageType', name: 'sendMessageType', component: special.sendMessageType,meta: { title: "", single: true }},
]
